import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FuseSidebarModule } from "@fuse/components";
import { FuseSharedModule } from "@fuse/shared.module";
import { ContentModule } from "app/layout/components/content/content.module";
import { NavbarModule } from "app/layout/components/navbar/navbar.module";
import { ToolbarModule } from "app/layout/components/toolbar/toolbar.module";
import { VerticalLayout1Component } from "app/layout/vertical/layout-1/layout-1.component";
import { Layout1Service } from "@app/layout/vertical/layout-1/layout-1.service";
import { V2ToolbarComponent } from "@app/layout/components/v2-toolbar/v2-toolbar.component";
import { V2NavbarComponent } from "@app/layout/components/v2-navbar/v2-navbar.component";
import { LegacyAlertModule } from "@vui/legacy-alert";
import { DisabledWhenExpiredDirective } from "@vadmin/account/auth";

@NgModule({
    declarations: [VerticalLayout1Component],
    imports: [
        RouterModule,

        FuseSharedModule,
        FuseSidebarModule,

        LegacyAlertModule,
        // ChatPanelModule,

        ContentModule,
        NavbarModule,
        ToolbarModule,
        V2ToolbarComponent,
        V2NavbarComponent,
        DisabledWhenExpiredDirective,
    ],
    exports: [VerticalLayout1Component],
    providers: [Layout1Service],
})
export class VerticalLayout1Module {}
